/*
 * A plain phone frame around a real screenshot of the H-Plate app.
 * Screens live in /public/images (720 x 1489, cut from the store listing).
 */

interface DeviceFrameProps {
  src: string;
  alt: string;
  /** Tailwind width classes for the whole device. */
  widthClass?: string;
  /** Load straight away (above the fold) instead of lazily. */
  eager?: boolean;
  className?: string;
}

/**
 * Renders an app screenshot inside a dark phone bezel.
 */
export default function DeviceFrame({
  src,
  alt,
  widthClass = "w-[250px] sm:w-[280px]",
  eager = false,
  className = "",
}: DeviceFrameProps) {
  return (
    <div className={`relative mx-auto ${widthClass} ${className}`}>
      <div className="rounded-[2.6rem] bg-[#0d1117] p-[9px] shadow-[0_40px_80px_-32px_rgba(2,20,14,0.65)] ring-1 ring-black/10">
        <div className="relative overflow-hidden rounded-[2.1rem] bg-black aspect-[720/1489]">
          <img
            src={src}
            alt={alt}
            width={720}
            height={1489}
            loading={eager ? "eager" : "lazy"}
            decoding="async"
            className="absolute inset-0 h-full w-full object-cover"
          />
          <div className="absolute left-1/2 top-[7px] h-[20px] w-[30%] -translate-x-1/2 rounded-full bg-black" aria-hidden />
        </div>
      </div>
    </div>
  );
}
